<template>
	<div class="filter-wrapper" :class="this.highlight ? 'selected' : 'not-selected'"
		style="border:1px solid var(--grey-5);border-radius:5px;">
		<div style="" :title="this.title" :class="this.disabled ? '' : 'link'">
			<!-- välja tillverkare-knapp -->
			<div class="filter-button" style="padding:5px;" @click="this.togglePopover();this.setupScroll();">
				<div class="flexcenter" style="height:26px;">

					<Icon v-if="this.manufactor" :fileName="this.highlight ? 'w3_circle_close_white' : 'w3_circle_close_dark'"
						style="width:16px;height:16px;" @click.stop="this.setManufactor(null);" />

					<b class="font-normal" :class="this.disabled ? 'disabled' : 'enabled'">{{ this.baseManufactorListLabel }}
					</b>
				</div>
				<div class="flexcenter  filter-button-label" style="flex-grow:1;">

					<div class="font-small" :class="this.disabled ? 'disabled' : 'enabled'" style="flex-grow:1;">{{
						this.manufactor ?
						this.manufactor.name : this.selectLabel }}</div>

					<Icon v-if="this.highlight"
						:fileName="this.popoverManufactor ? 'w3_chevron_up_white' : 'w3_chevron_down_white'"
						style="width:12px;height:12px;margin-left:10px;" />

					<Icon v-if="!this.highlight && this.popoverManufactor" fileName="w3_chevron_up_dark"
						style="width:12px;height:12px;margin-left:10px;" />

					<!-- om boxen är disabled/enabled -->
					<Icon v-if="!this.highlight && !this.popoverManufactor"
						:fileName=" this.disabled ? 'w3_chevron_down_light' : 'w3_chevron_down_dark'"
						style="width:12px;height:12px;margin-left:10px;" :link="!this.disabled" />

				</div>

			</div>

			<!-- tillverkare popover -->
			<div v-show="this.popoverManufactor" @mouseleave="this.popoverManufactor = false;"
				class="dropdown dropdown-w400 dropdown-h400 dropdown-p10 dropdown-shadow" style="background:var(--grey-3);">



				<!-- lista tillverkare -->
				<div style="height:100%;">
					<div class="flexcenter">

						<h3>Tillverkare</h3>
						<b style="flex-grow:1;"></b>
						<img src="@/assets/button_close_dark.png" class="link" @click="this.popoverManufactor = false;"
							style="height:20px;width:20px;margin-right:5px;" />
					</div>

					<!-- sök tillverkare -->
					<div style="height:40px;margin-top:5px;">

						<div class="form textField" :title="'filter: ' + this.filterManufactor" style="height:30px;padding:0px;">
							<input type="text" placeholder="Sök tillverkare..." v-model="filterManufactor" />
							<img src="@/assets/w3_button_close_light.png" v-if="this.filterManufactor"
								@click="this.filterManufactor = ''" style="height:20px;width:20px;margin-right:5px;" />
						</div>


					</div>

					<!-- lista tillverkare-->
					<div ref="manufactorList" style="overflow:scroll;max-height:calc(100% - 100px);">

						<div v-for="(manufactor, index) in this.manufactorList" :key="index"
							:style="this.manufactor && this.manufactor.manufactorId == manufactor.manufactorId ? 'background:var(--grey-5);' : 'background:var(--grey-1);'"
							style="margin-bottom:5px;" class="link">

							<!-- klickbar kategori-->


							<div class="manufactorLabel flexcenter"
								@click="this.setManufactor(manufactor); this.popoverManufactor = false;" ref="manufactors"
								:id="'manufactor-' + manufactor?.manufactorId">
								{{ manufactor?.name }}



							</div>


						</div>
					</div>
				</div>




			</div>
		</div>
	</div>
</template>
<script>
import listHelper from '@/helper/list-helper';
import { STORE_GETTER } from '../../../store/store';

export default {
	name: "SelectManufactor",
	components: {},
	props:{
		baseManufactorList: Array,
		manufactor:Object,
		baseManufactorListAllLength: Number

	},
	mixins: [],
	data() {
		return {
			//manufactor: null,
			popoverManufactor: false,
			filterManufactor: null,
		};
	},
	computed: {

		selectLabel(){
			
			if (this.baseManufactorList) {

				if (this.baseManufactorList.length > 30) {
					return "Välj tillverkare";
				} else {
					return "Välj bland " + String(this.baseManufactorList.length) + " st tillverkare";
				}


			}

			return "Välj tillverkare"
		},

		baseManufactorListLabel(){

			return "Tillverkare"
/*

			if (this.baseManufactorList){

				if (this.baseManufactorList.length > 80){
					return "Tillverkare";
				}else{
					return "Tillverkare (" + String(this.baseManufactorList.length) + ")";
				}

				
			}

			return "Tillverkare"
/*
			if (this.baseManufactorListAllLength && this.baseManufactorListAllLength > 0){
				return "Tillverkare (" + String(this.baseManufactorListAllLength) + ")";
			}

			return "Tillverkare ";
*/
		
		},

		manufactorList() {
			
			if (this.baseManufactorList) {

				if (this.filterManufactor == null || this.filterManufactor == "") {
					return this.baseManufactorList
				}

				const list = this.baseManufactorList.filter(manufactor => {

					console.log('FP: manufactor, ', manufactor);

					// manufactor.search 
					return listHelper.filter(manufactor.name, this.filterManufactor)

				})

				return list;
			}

			return null;
		},

		productCountManufactor() {
			return "xxx";
		},

		highlight() {
			const searchProductConfig = this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];

			if (!searchProductConfig) {
				return false;
			}


			return searchProductConfig.manufactor;
		},
		title() {
			if (!this.disabled) {
				return "Välj tillverkare"
			} else {
				return "Välj först 'Alla produkter' du visar bara ett urval av produkter. ";
			}
		},
		disabled() {
			return !this.$store.getters[STORE_GETTER.PRODUCT_SEARCH_ENABLED];
		}

	},
	watch: {
		popoverManufactor: function (popoverManufactor) { // TODO kolla om denna behövs

			if (popoverManufactor) {
				this.$emit("selectPopoverOpen", "popoverManufactor");
			}

		},
		/*popoverManufactor: function (popverManufactor) {

			console.log('FP: popverManufactor', popverManufactor);

			setTimeout(() => {
				this.setupScroll()
			}, 100);
		},*/

	},
	updated(){
		this.setupScroll();
	},
	methods: {
		togglePopover() {
			if (this.disabled) {
				alert(this.title)

				return;
			}

			this.popoverManufactor = !this.popoverManufactor
		},
		closePopover() {
			this.popoverManufactor = false
		},
		setManufactor(manufactor){
			this.$emit('manufactorSelected', manufactor)
			
		},

		setupScroll() {

			if (this.manufactor && this.$refs.manufactors) {
				console.log('FP: refs.manufactors: ', this.$refs.manufactors);

				const manufactorDiv = this.$refs.manufactors.find(manufactorDiv => manufactorDiv.id == "manufactor-" + this.manufactor.manufactorId)
				if (manufactorDiv) {
					manufactorDiv.scrollIntoView({ block: "nearest", inline: "nearest" })
				}

			} else if (this.$refs.manufactorList) {
				this.$refs.manufactorList.scrollTop = 0;
			}
		},

	},
	created() {

	}
};
</script>

<style scoped>

div.filter-wrapper.not-selected {
	background: var(--grey-2);
}



div.filter-wrapper.selected div.filter-button {
	background: var(--bg-message);
	color: white;
}

.font-normal {
	font-size: var(--filter-wrapper-font-normal, 1rem);
}

.font-small {
	font-size: var(--filter-wrapper-font-small, 0.85rem);
}

div.filter-wrapper div.filter-button div.filter-button-label {
	margin-top: 2px;
}

@media (max-width:768px) {

	div.filter-wrapper {
		width: 100%;
		margin-bottom: 5px;
	}

	div.filter-wrapper div.filter-button {
		display: flex;
		flex-direction: row;

	}

	div.filter-wrapper div.filter-button div.filter-button-label {
		padding-left: 5px;
		margin-top: 0px;
	}
}

div.manufactorLabel {
	padding: 5px;
}

@media (max-width:768px) {
	div.manufactorLabel {
		padding: 10px;
	}
}

b.disabled {
	color: var(--font-color-grey-light);
}

div.disabled {
	color: var(--font-color-grey-light);
}
</style>